import React from "react";



import ClientProfileView from "./ClientProfileView";

import useViewClient from "../hooks/useViewClient";



const CompanyViewClient = () => {

  const viewProps = useViewClient();



  return <ClientProfileView {...viewProps} />;

};



export default CompanyViewClient;

